//
// Module for the service purchase edit view
//
rs.module("content/system/configuration/servicepurchase/edit",

    [
        "controls/components/event-banner",
        "common/select-helper"
    ],

    function (eventBanner, selectHelper) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, codeValues, columnIds, grid, backendUrl, serviceTypes, serviceClassificationOptions) {

            // Unpack js selectors
            var form = $.js(jsSelectors.form);

            var hiddenDetailUpdateToken = form.js(jsSelectors.hiddenDetailUpdateToken);
            var hiddenDetailRuleKey = form.js(jsSelectors.hiddenDetailRuleKey);
            var addDetailButton = form.js(jsSelectors.addDetailButton, { required: false });
            var cancelDetailButton = form.js(jsSelectors.cancelDetailButton, { required: false });
            var detailContractTypeSelect = form.js(jsSelectors.detailContractTypeSelect);
            var detailServiceTypeSelect = form.js(jsSelectors.detailServiceTypeSelect);
            var detailServiceClassificationSelect = form.js(jsSelectors.detailServiceClassificationSelect);
            var serviceAllocationMethodSelect = form.js(jsSelectors.serviceAllocationMethodSelect);
            var writeOffAmountInput = form.js(jsSelectors.writeOffAmountInput);
            var timeBlockFlag = form.js(jsSelectors.timeBlockFlag);
            var payrollDeductionFlag = form.js(jsSelectors.payrollDeductionFlag);
            var useRefundFlag = form.js(jsSelectors.useRefundFlag);
            var preTaxPaymentFlag = form.js(jsSelectors.preTaxPaymentFlag);
            var detailEffectiveDate = form.js(jsSelectors.detailEffectiveDate);
            var detailTerminationDate = form.js(jsSelectors.detailTerminationDate);

            // Get Select Helpers for populating drop downs
            var detailContractTypeSelectHelper = selectHelper.getHelper(detailContractTypeSelect);
            var detailServiceTypeSelectHelper = selectHelper.getHelper(detailServiceTypeSelect);
            var detailServiceClassificationSelectHelper = selectHelper.getHelper(detailServiceClassificationSelect);
            var serviceAllocationMethodSelectHelper = selectHelper.getHelper(serviceAllocationMethodSelect);

            // Service Type and Service Classification are disabled if Contract Type is Non-Service Purchase
            detailContractTypeSelect.change(onDetailContractTypeChange);

            // Setup listeners to checkboxes to flip-flop them.
            timeBlockFlag.change(toggleCheckboxes);
            useRefundFlag.change(toggleCheckboxes);

            if (grid) {

                // On add button click, clear the detail form
                addDetailButton.click(function () {

                    clearAllErrors();
                    eventBanner.removeAllMessages();
                    grid.selectedValues = null;

                    // Reset inputs
                    [
                        hiddenDetailUpdateToken,
                        writeOffAmountInput,
                        detailEffectiveDate,
                        detailTerminationDate
                    ].forEach((input) => input.clearErrors().val(''));
                    writeOffAmountInput.val('$0.00');

                    // Reset checkboxes
                    [
                        timeBlockFlag,
                        payrollDeductionFlag,
                        useRefundFlag,
                        preTaxPaymentFlag
                    ].forEach((checkbox) => checkbox.setChecked(false));

                    // Reset selectors
                    detailContractTypeSelectHelper.setValue(codeValues.servicePurchase);
                    onDetailContractTypeChange();
                    detailServiceTypeSelectHelper.selectIndex(0);
                    serviceAllocationMethodSelectHelper.selectIndex(0);
                    detailServiceClassificationSelectHelper.replaceOptions(serviceClassificationOptions);

                    // Enable Disable fields
                    toggleCheckboxes();
                });

                // On cancel button click, select first entry and clear event banner.
                cancelDetailButton.click(function () {
                    grid.selectedValues = null;
                    grid.selectFirstRow();
                    clearAllErrors();
                    eventBanner.removeAllMessages();
                });

                // Listen for row selection 
                grid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {

                        $.getJSON(backendUrl, { spcDetailRuleKey: rows[0][columnIds.detailRuleKey] }).done(function (data) {

                            // Hidden Token
                            hiddenDetailUpdateToken.val(data.updateToken);
                            hiddenDetailRuleKey.val(data.detailRuleKey);

                            // Inputs
                            writeOffAmountInput.val(data.writeOffAmount);
                            detailEffectiveDate.val(data.effectiveDate);
                            detailTerminationDate.val(data.terminationDate);

                            // Checkboxes
                            payrollDeductionFlag.setChecked(data.payrollDeductionFlag);
                            preTaxPaymentFlag.setChecked(data.preTaxPaymentsFlag);
                            timeBlockFlag.setChecked(data.timeBlockFlag);
                            useRefundFlag.setChecked(data.refundContributionFlag);
                            toggleCheckboxes();

                            // Drop Downs
                            detailContractTypeSelectHelper.setValue(data.contractType);
                            onDetailContractTypeChange();
                            detailServiceTypeSelectHelper.setValue(data.serviceType);
                            detailServiceClassificationSelectHelper.setValue(data.serviceClassifications);
                            serviceAllocationMethodSelectHelper.setValue(data.allocationMethod);

                            clearAllErrors();
                            eventBanner.removeAllMessages();
                        });
                    }

                    _executeSelectionChanged = true;
                });
            }

            // Toggles the Service Type and Service Classification drop downs based on selected Contract Type
            function onDetailContractTypeChange() {
                if (detailContractTypeSelect.val() == codeValues.nonServicePurchase) {

                    detailServiceTypeSelectHelper.clearOptions();
                    detailServiceTypeSelect.clearErrors();
                    detailServiceTypeSelectHelper.setDisabled(true);

                    detailServiceClassificationSelectHelper.clearOptions();
                    detailServiceClassificationSelect.clearErrors();
                    detailServiceClassificationSelectHelper.setDisabled(true);

                    serviceAllocationMethodSelectHelper.setValue(codeValues.notApplicable);
                    serviceAllocationMethodSelect.clearErrors();
                    serviceAllocationMethodSelectHelper.setDisabled(true);
                }
                else {

                    detailServiceTypeSelectHelper.replaceOptions(serviceTypes, { withBlank: true });
                    detailServiceTypeSelectHelper.setDisabled(false);

                    detailServiceClassificationSelectHelper.replaceOptions(serviceClassificationOptions);
                    detailServiceClassificationSelectHelper.setDisabled(false);

                    serviceAllocationMethodSelectHelper.setDisabled(false);
                    serviceAllocationMethodSelectHelper.selectIndex(0);
                }
            }

            // Flip-flop the Use Time Blocks flag and the Use Refund Contribution Allocation Flag
            function toggleCheckboxes() {
                timeBlockFlag.prop('disabled', useRefundFlag.is(":checked"));
                if (useRefundFlag.is(":checked")) {
                    timeBlockFlag.prop('checked', false);
                }

                useRefundFlag.prop('disabled', timeBlockFlag.is(":checked"));
                if (timeBlockFlag.is(":checked")) {
                    useRefundFlag.prop('checked', false);
                }
            }

            // Clear all client-side validation errors
            function clearAllErrors() {

                // Clear errors from inputs
                [
                    detailEffectiveDate,
                    writeOffAmountInput,
                    detailTerminationDate
                ].forEach((input) => input.clearErrors());

                detailServiceTypeSelect.clearErrors();
                detailServiceClassificationSelect.clearErrors();
                serviceAllocationMethodSelect.clearErrors();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);